// @flow

import createVersions from './create-versions';
import queries from './queries_web_apple_macos';

export default createVersions('macos', queries, false);
